module.exports = __webpack_public_path__ + "asset/image-ic_category_19-a59177e26c217a59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_19.svg
// module id = apxD
// module chunks = 0